export class VerifyPhoneReqRes {

  constructor(
    public phone: string = null,
    public verificationCode: string = null
  ) {}

}
